// Keycloak only offers a skippable ("Not now") passkey registration page when the app asks for it with
// kc_action, so after a sign-in we check the user's credentials and send anyone without a passkey there once.
const PASSKEY_ACTION = 'webauthn-register-passwordless'
const PASSKEY_CREDENTIAL = 'webauthn-passwordless'

const answeredKey = sub => `passkeyEnrolmentAnswered:${sub}`

const hasAnswered = sub => {
  try {
    return window.localStorage.getItem(answeredKey(sub)) !== null
  } catch {
    return false
  }
}

const rememberAnswer = (sub, status) => {
  try {
    window.localStorage.setItem(answeredKey(sub), status)
  } catch {
    // Without storage the offer simply comes back on the next sign-in.
  }
}

const hasPasskey = async (userManager, user) => {
  const response = await fetch(`${userManager.settings.authority}/account/credentials?type=${PASSKEY_CREDENTIAL}`, {
    headers: { Authorization: `Bearer ${user.access_token}`, Accept: 'application/json' },
  })
  if (!response.ok) {
    throw new Error(`Credential lookup failed (HTTP ${response.status})`)
  }
  const credentialTypes = await response.json()
  return credentialTypes.some(type => type.type === PASSKEY_CREDENTIAL && type.userCredentialMetadatas?.length > 0)
}

/** Returns true when it has redirected to Keycloak's passkey registration page. */
export const offerPasskeyEnrolment = async (userManager, user) => {
  const sub = user.profile.sub
  const actionStatus = new URLSearchParams(window.location.search).get('kc_action_status')

  if (actionStatus) {
    rememberAnswer(sub, actionStatus)
    return false
  }
  if (hasAnswered(sub)) {
    return false
  }

  try {
    if (await hasPasskey(userManager, user)) {
      return false
    }
  } catch (error) {
    console.warn('Skipping passkey enrolment offer', error)
    return false
  }

  await userManager.signinRedirect({ state: user.state, extraQueryParams: { kc_action: PASSKEY_ACTION } })
  return true
}
